@if (!this.compactView()) {
  <div class="space-between align-center">
    <cam-grid-tag class="d-flex" [gridId]="this.gridId()"></cam-grid-tag>

    <cam-grid-control
      [gridId]="this.gridId()"
      [show]="{
        search: true,
        searchPlaceholder: 'files.documents.search-placeholder',
        switchView: true,
      }"
    ></cam-grid-control>
  </div>
}

@let list = this.data$() | async;
<div class="content mt-space-md">
  <cam-empty
    [isEmpty]="!list || list.length === 0"
    [text]="this.emptyText()"
    [showMessage]="!!this.emptyText()"
    icon="ghost"
    iconSize="xl"
    [isLight]="false"
  >
    @if (list && list.length) {
      <cam-ag-grid
        [gridId]="this.gridId()"
        [cardTemplate]="this.cardTemplate"
        [data]="list"
        [fieldsOverrides]="this.fieldsOverrides"
        [gridOptions]="{
          domLayout: 'autoHeight',
        }"
      ></cam-ag-grid>
    }
  </cam-empty>
</div>

<ng-template #cardTemplate let-items="items">
  <cam-files-display [documentsIds]="this.idsFromItems(items)"></cam-files-display>
</ng-template>

<cam-layout-full-panel
  [toggleState]="this.slideModal.open()"
  (closeEvent)="this.slideModal.open.set(false)"
  title="files.slide.title"
  type="modal"
  size="lg"
  orientation="vertical"
>
  @if (this.slideModal.open()) {
    <cam-files-slide
      [initial]="this.slideModal.input()?.initial ?? null"
      [files]="this.slideModal.input()?.files ?? []"
    ></cam-files-slide>
  }
</cam-layout-full-panel>
